import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import Currency from '@/components/Currency';

function Income({ income }) {
  return (
    <Grid container>
      <Grid container item direction="column">
        <Grid item>
          <Typography variant="h6">Breakdown</Typography>
        </Grid>
        <Grid item>
          <List>
            <ListItem>
              <ListItemText
                primary={<Currency number={income.total} />}
                secondary="Total Income"
              />
            </ListItem>
            {income.sections.map(section => (
              <ListItem key={section.name}>
                <ListItemText
                  primary={section.name}
                  secondary={
                    <>
                      Total: <Currency number={section.income} />
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Income;
